import { apiLoadSettings, apiSaveSettings } from "./baseApi"

export const apiSaveOtherSettings = (data, callback) => {
  apiSaveSettings(data, callback, 'other')
}

export const apiLoadOtherSettings = (callback) => {
  apiLoadSettings(callback, 'other')
}